(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hypnos-reviews-page"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hypnos-reviews-page'))customElements.define('hypnos-reviews-page',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.grid=this.querySelector('[data-grid]');if(!this.grid)return;
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.cards=[...this.querySelectorAll('[data-review]')];this.limit=6;
  this.rating=this.querySelector('[data-rating]:not(article)');this.sort=this.querySelector('[data-sort]');this.search=this.querySelector('[data-search]');
  this.querySelector('[data-toolbar]').hidden=false;
  [this.rating,this.sort,this.search].forEach(el=>el.addEventListener('input',()=>{this.limit=6;this.render()},options));
  this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=6;this.render()},options);
  this.addEventListener('shopify:block:select',e=>{this.rating.value='all';this.search.value='';this.limit=this.cards.length;this.render();this.cards.find(c=>c.dataset.blockId===e.detail.blockId)?.scrollIntoView({block:'center',behavior:'auto'})},options);
  this.render();
 }
 render(){
  const query=this.search.value.toLocaleLowerCase().trim();
  const matches=this.cards.filter(c=>(this.rating.value==='all'||c.dataset.rating===this.rating.value)&&c.textContent.toLocaleLowerCase().includes(query));
  const mode=this.sort.value;
  const stamp=c=>{const d=c.dataset.date;return /^\d{4}-\d{2}-\d{2}$/.test(d)?(Date.parse(d)||0):0};
  if(mode==='newest')matches.sort((a,b)=>stamp(b)-stamp(a));
  if(mode==='highest')matches.sort((a,b)=>Number(b.dataset.rating)-Number(a.dataset.rating));
  if(mode==='lowest')matches.sort((a,b)=>Number(a.dataset.rating)-Number(b.dataset.rating));
  this.cards.forEach(c=>c.hidden=true);
  matches.forEach((c,i)=>{this.grid.append(c);c.hidden=i>=this.limit});
  this.querySelector('[data-no-results]').hidden=matches.length>0;
  this.querySelector('[data-more]').hidden=matches.length<=this.limit;
  this.querySelector('[data-results]').textContent=`${Math.min(this.limit,matches.length)} of ${matches.length} reviews`;
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hypnos-rider-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hypnos-rider-reviews')) {
  customElements.define('hypnos-rider-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.hrr__track');
      if (!this.track) return;
      this.cards = [...this.querySelectorAll('.hrr__card')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.editorSelected = false;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.listen = (target, event, handler) => target.addEventListener(event, handler, { signal });
      this.listen(this, 'click', e => {
        const button = e.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-prev')) this.go(this.index - 1);
        if (button.hasAttribute('data-next')) this.go(this.index + 1);
        if (button.hasAttribute('data-index')) this.go(Number(button.dataset.index));
        if (button.hasAttribute('data-pause')) {
          this.paused = !this.paused;
          button.textContent = this.paused ? 'Play' : 'Pause';
          button.setAttribute('aria-pressed', String(this.paused));
          button.setAttribute('aria-label', this.paused ? 'Resume automatic scrolling' : 'Pause automatic scrolling');
        }
        this.schedule();
      });
      this.listen(this.track, 'keydown', e => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        this.go(e.key === 'Home' ? 0 : e.key === 'End' ? this.cards.length - 1 : this.index + (e.key === 'ArrowRight' ? 1 : -1));
        this.schedule();
      });
      this.listen(this.track, 'scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        this.schedule();
      });
      this.listen(this, 'pointerenter', e => { if(e.pointerType === 'mouse'){ this.hovered = true; this.schedule(); } });
      this.listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      this.listen(this, 'pointerdown', () => { this.dragging = true; this.schedule(); });
      this.listen(window, 'pointerup', () => { this.dragging = false; this.schedule(); });
      this.listen(window, 'pointercancel', () => { this.dragging = false; this.schedule(); });
      this.listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      this.listen(this, 'focusout', e => { this.focused = this.contains(e.relatedTarget); this.schedule(); });
      this.listen(document, 'visibilitychange', () => this.schedule());
      this.listen(this.motion, 'change', () => this.schedule());
      this.listen(this, 'shopify:block:select', e => {
        const index = this.cards.findIndex(card => card.dataset.blockId === e.detail.blockId);
        if (index >= 0) { this.editorSelected = true; this.go(index, false); this.schedule(); }
      });
      this.listen(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.15 });
      this.observer.observe(this.track);
      this.setAttribute('data-ready', '');
      this.go(this.cards.length > 2 ? 1 : 0, false);
    }
    update() {
      const bounds = this.track.getBoundingClientRect();
      const center = bounds.left + bounds.width / 2;
      let closest = Infinity;
      this.cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < closest) { closest = distance; this.index = i; }
      });
      this.cards.forEach((card, i) => card.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    }
    go(index, smooth = true) {
      this.index = (index + this.cards.length) % this.cards.length;
      const card = this.cards[this.index].getBoundingClientRect();
      const track = this.track.getBoundingClientRect();
      this.track.scrollTo({ left: this.track.scrollLeft + card.left + card.width / 2 - track.left - track.width / 2, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
      if (!smooth) this.update();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.cards.length < 2 || this.paused || this.hovered || this.focused || this.dragging || !this.visible || this.editorSelected || document.hidden || this.motion.matches || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => { this.go(this.index + 1); this.schedule(); }, Number(this.dataset.delay) || 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
